<template>
    <div class="container-fluid">
        <label-modal :show.sync="showLabelModal" :booking="labelBooking" v-if="showLabelModal"></label-modal>
        <div class="row">
            <heading>{{ $t('booking.draftMenuName') }}
                <template v-slot:actions>
                    <a href="/bookings/create" class="btn btn-primary mx-1" v-if="$root.isAdmin === false">{{ $t('booking.newDraft') }}</a>
                    <button class="btn btn-primary mx-1"  v-if="draftsSelected && $root.isAdmin === false" @click="bookMultipleDrafts">{{ $t('booking.bookChosenDrafts') }}</button>
                </template>
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <div v-if="drafts.length === 0" class="text-center">
                        <h1>{{ $t('booking.emptyStateDrafts') }}</h1>
                        <img src="/storage/empty-state.svg" height="200"/>
                    </div>
                    <div v-else>
                        <div class="row border-bottom border-secondary py-3 h6">
                            <div class="col-1"></div>
                            <div class="col-1 text-center">{{ $t('booking.fields.created_at') }}</div>
                            <div class="col-1" v-if="$root.isAdmin">{{ $t('company.fields.lgt_customer_number') }}</div>
                            <div class="col-3">{{ $t('booking.sender') }}</div>
                            <div class="col-4">{{ $t('booking.recipient') }}</div>
                            <div :class="{'col-1': $root.isAdmin, 'col-2': !$root.isAdmin}">{{ $t('booking.goodsUnits') }}</div>
                            <div class="col-1"></div>
                        </div>
                        <DynamicScroller
                            :items="drafts"
                            :min-item-size="54"
                            class="row"
                            pageMode
                        >
                            <template v-slot="{ item, index, active }">
                                <DynamicScrollerItem
                                    :item="item"
                                    :active="active"
                                    :size-dependencies="[
                                      item.company.name,
                                    ]"
                                    :data-index="index"
                                    class="col-12"
                                >
                                    <div class="row py-3 border-bottom border-secondary"
                                         :id="'booking-' + item.id"
                                         @click="goToBooking(item)">
                                        <div class="col-1">
                                            <div class="form-group mb-0 text-center">
                                                <div class="custom-control custom-checkbox"
                                                     @click.stop>
                                                    <input type="checkbox" class="custom-control-input" :id="'booking-check' + item.id" v-model="item.checked">
                                                    <label class="custom-control-label" :for="'booking-check' + item.id" @click.stop></label>
                                                </div>
                                            </div>
                                            <div class="badge badge-info" v-if="item.is_return">{{ $t('booking.returnBookingBadgeText') }}</div>
                                        </div>
                                        <div class="col-1 text-center">
                                            <span :title="item.created_at.format('LLL')">{{ item.created_at.format('D MMMM') }}</span>
                                        </div>
                                        <div class="col-1" v-if="$root.isAdmin">
                                            {{ item.company.lgt_customer_number }}
                                        </div>
                                        <div class="col-3">
                                            <p class="h5">{{ item.name }}</p>
                                            <p class="text-muted">{{ item.reference_number }}</p>
                                        </div>
                                        <div class="col-4">
                                            <p class="h5">{{ item.recipient.name }}, {{ item.recipient.country }}</p>
                                            <p class="text-muted">{{ item.recipient.reference_number }}</p>
                                        </div>
                                        <div :class="{'col-1': $root.isAdmin, 'col-2': !$root.isAdmin}">
                                            {{ item.PLLCount }} {{ $t('booking.indexUnitTypes.PLL') }}<br/>
                                            {{ item.KLLCount }} {{ $t('booking.indexUnitTypes.KLL') }}<br/>
                                            {{ new Intl.NumberFormat().format(item.CBMCount / 1000) }} {{ $t('booking.indexUnitTypes.M3') }}
                                        </div>
                                        <div class="col-1 text-right">
                                            <b-dropdown variant="link" right toggle-class="text-decoration-none py-0"
                                                        @show="dropdownShow"
                                                        @hide="dropdownHide"
                                                        class="float-right"
                                            >
                                                <template v-slot:button-content>
                                                    {{ $t('core.actions.more') }}
                                                </template>
                                                <b-dropdown-item :href="'/bookings/' + item.id + '/edit'" v-if="item.is_draft">
                                                    {{ $t('core.actions.details') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item href="#" @click.prevent.stop="showLabelModalFn(item)">
                                                    {{ $t('booking.sendLabel') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="$root.isAdmin === false" href="#" @click.prevent.stop="bookDraft(item)">
                                                    {{ $t('booking.book') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="$root.isSuperAdmin || item.is_draft" href="#" @click.prevent.stop="deleteBooking(item.id)">
                                                    {{ $t('core.actions.deleteBooking') }}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </DynamicScrollerItem>
                            </template>
                        </DynamicScroller>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import LabelModal from '@/Components/LabelModal'
import { BDropdown } from 'bootstrap-vue'

export default {
    name: 'DraftIndex',
    components: { DynamicScroller, DynamicScrollerItem, LabelModal, BDropdown },
    data: function () {
        return {
            drafts: [],
            showLabelModal: false,
            labelBooking: null,
        }
    },
    methods: {
        dropdownShow (e) {
            e.target.closest('.vue-recycle-scroller__item-view').style.zIndex = '1'
        },
        dropdownHide (e) {
            e.target.closest('.vue-recycle-scroller__item-view').style.zIndex = '0'
        },
        goToBooking (booking) {
            location.href = '/bookings/' + booking.id + '/edit'
        },
        showLabelModalFn (booking) {
            this.labelBooking = booking
            this.showLabelModal = true
        },
        deleteBooking (bookingId) {
            axios.delete('/bookings/' + bookingId).then((response) => {
                const index = this.drafts.findIndex((x) => x.id === bookingId);
                this.drafts.splice(index, 1);
                this.$saveSuccess();
            })
        },
        bookDraft(booking){
            axios.post('/bookings/' + booking.id + '/book-draft').then((response) => {
                const index = this.drafts.findIndex((x) => x.id === booking.id);
                this.drafts.splice(index, 1);
                this.$saveSuccess();
            }).catch((error) => {
                if(error.response.status === 422)
                    this.$saveError(this.$t('booking.bookDraftError'));
            })
        },
        bookMultipleDrafts(){
            const drafts = this.drafts.filter((item) => item.checked === true)
            const draftIds = drafts.map((item) => item.id);
            axios.post('/bookings/book-multiple-drafts', {ids: draftIds}).then((response) => {
                drafts.forEach((item) => {
                    const index = this.drafts.findIndex((x) => x.id === item.id);
                    this.drafts.splice(index, 1);
                })
                this.$saveSuccess();
            }).catch((error) => {
                if(error.response.status === 422){
                    error.response.data.completed.forEach((item) => {
                        const index = this.drafts.findIndex((x) => x.id === item);
                        this.drafts.splice(index, 1);
                    })
                    this.$saveError(this.$t('booking.bookDraftErrorOnSome', {completed: error.response.data.completed.length, failed: error.response.data.failed.length}));
                }
            })
        }
    },
    computed: {
        draftsSelected () {
            return this.drafts.filter((item) => item.checked === true).length > 0
        }
    },
    created () {
        this.drafts = lgt.drafts.map((item) => {
            item.created_at = moment.utc(item.created_at).tz(moment.tz.guess())
            item.modal = true
            item.checked = false;
            return item
        })
    },
}
</script>
